import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { AUTH_ENABLED, apiTokenRequest } from './msalConfig';
import { getMsalInstance } from './msalInstance';

/**
 * Acquires an access token for the API silently when possible.
 * If silent acquisition fails (token expired and no refresh), redirects to login.
 * Returns null if auth is disabled (DevMode).
 */
export async function getAccessToken(): Promise<string | null> {
  if (!AUTH_ENABLED) return null;

  const instance = getMsalInstance();
  const account = instance.getActiveAccount();

  if (!account) {
    // No active account — initiate login redirect. The user will land back here
    // after authentication and the next call to getAccessToken will succeed.
    await instance.loginRedirect(apiTokenRequest);
    // The line below is technically unreachable because loginRedirect navigates away,
    // but TypeScript needs a return.
    return null;
  }

  try {
    const result = await instance.acquireTokenSilent({
      ...apiTokenRequest,
      account,
    });
    return result.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      // Refresh token expired or revoked — full re-login required.
      await instance.acquireTokenRedirect(apiTokenRequest);
      return null;
    }
    throw error;
  }
}